import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";

export default async function markClientAsUnreaded(userdata: OperatorApplicationApi.OperatorApplicationClientOpenApiModel) {
    if (!OperatorAccountStore.showFreeDialogForSite(userdata.siteId)) {
        let p: OperatorApplicationApi.OperatorMessageMarkAsUnreadedOpenApiModel = {
            username: userdata.username
        };
        (await (new OperatorApiRequest({
            url: "/message/markAsUnreaded",
            p
        })).send()).showMessageOnError();
    }
}